import {
  fetchBpRoutine,
  clearSelectedBpRoutine,
  getUserRelationToBpRoutine,
  getBpConnectedUsersRoutine,
  getBpConnectedUsersByEmailRoutine,
  getUsersByEmailRoutine,
  clearConnectedUsersRoutine,
  clearUsersFoundByEmailRoutine,
  searchLocalFilesRoutine,
  bulkShareFilesRoutine,
  fetchExternalSharedFilesRoutine,
  fetchInternalSharedUsersRoutine,
  bulkUnsharedFilesRoutine,
  fetchSharedUsersForFilesRoutine,
  unshareAllFilesForEmailRoutine, checkUserByEmailRoutine, bulkEditFilesRoutine,
  accessControlFetchRoutine,
  accessControlApproveRoutine,
  accessControlDenyRoutine,
  accessControlAssignRoutine,
  bpPeopleCountRoutine,
} from 'features/bpDetails/ducks/actions'
import {
  assignUserToBpRoutine,
  revokeAccessToBpRoutine,
  removeAccessToBpRoutine,
  inviteUserToBpRoutine,
  cancelInvitationRoutine,
  acceptInvitationRoutine,
  denyInvitationRoutine,
  restoreAccessToBpRoutine,
  editUserRelationToBpRoutine
} from 'features/accessControl/ducks/actions'
import { pathOr, propOr } from 'ramda'
import {
  createBpRoutine,
  removeNoteRoutine
} from 'features/createBp/ducks/actions'
import { logoutUserRoutine } from 'features/auth/ducks/actions'
import emptyBpDetailsState from 'features/bpDetails/ducks/state'
import { fetchBpUnitsRoutine } from 'ducks/units/actions'

const ACCESS_CHANGED = [
  accessControlAssignRoutine.SUCCESS,
  accessControlApproveRoutine.SUCCESS,
  accessControlDenyRoutine.SUCCESS,
  assignUserToBpRoutine.SUCCESS,
  revokeAccessToBpRoutine.SUCCESS,
  removeAccessToBpRoutine.SUCCESS,
  inviteUserToBpRoutine.SUCCESS,
  cancelInvitationRoutine.SUCCESS,
  acceptInvitationRoutine.SUCCESS,
  denyInvitationRoutine.SUCCESS,
  restoreAccessToBpRoutine.SUCCESS,
  editUserRelationToBpRoutine.SUCCESS
]

export default (state = emptyBpDetailsState, action) => {
  if (ACCESS_CHANGED.includes(action.type)) {
    state = { ...state, accessVersion: (state.accessVersion || 0) + 1 }
  }
  switch (action.type) {
    case bpPeopleCountRoutine.SUCCESS:
      return { ...state, peopleCount: action.payload }
    case fetchBpRoutine.SUCCESS:
      return {
        ...state,
        selectedBp: action.payload,
        currentBpFiles: action.payload.files || []
      }
    case removeNoteRoutine.SUCCESS:
      return {
        ...state,
        selectedBp: {
          ...state.selectedBp,
          notes: state.selectedBp.notes.filter(e => e.id !== action.payload)
        }
      }
    case getUsersByEmailRoutine.SUCCESS:
      return {
        ...state,
        relationship: {
          ...state.relationship,
          [action.payload.type]: action.payload.data
        }
      }
    case searchLocalFilesRoutine.SUCCESS: {
      // Payload can be either an array (legacy callers) or { results, truncated }
      const payload = action.payload
      const isObjectPayload = payload && !Array.isArray(payload) && typeof payload === 'object'
      return {
        ...state,
        localSearchFileResults: isObjectPayload
          ? (payload.results || [])
          : (Array.isArray(payload) ? payload : []),
        localSearchTruncated: isObjectPayload ? !!payload.truncated : false,
        isSearching: false
      }
    }
    case searchLocalFilesRoutine.REQUEST:
      return {
        ...state,
        localSearchFileResults: state.localSearchFileResults || [],
        isSearching: true
      }

    case searchLocalFilesRoutine.FAILURE:
      return {
        ...state,
        localSearchFileResults: [], // Clear results on failure
        localSearchTruncated: false,
        isSearching: false
      }
    case clearUsersFoundByEmailRoutine.SUCCESS:
      return {
        ...state,
        relationship: emptyBpDetailsState.relationship
      }
    case getBpConnectedUsersRoutine.SUCCESS:
    case getBpConnectedUsersByEmailRoutine.SUCCESS:
      return {
        ...state,
        connectedUsers: action.payload
      }
    case getBpConnectedUsersByEmailRoutine.FAILURE:
    case clearConnectedUsersRoutine.SUCCESS:
      return {
        ...state,
        connectedUsers: []
      }
    case createBpRoutine.SUCCESS:
      return {
        ...state,
        selectedBp: action.payload
      }
    case logoutUserRoutine.SUCCESS:
      return emptyBpDetailsState
    case clearSelectedBpRoutine.SUCCESS:
      return {
        ...state,
        selectedBp: {}
      }
    case getUserRelationToBpRoutine.SUCCESS:
      return {
        ...state,
        userRelation: action.payload
      }
    case bulkShareFilesRoutine.REQUEST:
      return {
        ...state,
        bulkShareStatus: {
          loading: true,
          error: null
        }
      }
    case bulkShareFilesRoutine.SUCCESS:
      return {
        ...state,
        bulkShareStatus: {
          loading: false,
          error: null,
          sharedCount: action.payload.sharedCount,
          warning: action.payload.warning
        }
      }
    case bulkShareFilesRoutine.FAILURE:
      return {
        ...state,
        bulkShareStatus: {
          loading: false,
          error: action.payload
        }
      }
    case fetchExternalSharedFilesRoutine.REQUEST:
      return {
        ...state,
        externalSharedFiles: {
          loading: true,
          error: null,
          data: []
        }
      }
    case fetchExternalSharedFilesRoutine.SUCCESS:
      return {
        ...state,
        externalSharedFiles: {
          loading: false,
          error: null,
          data: action.payload,
          meta: action.payload.meta

        }
      }
    case fetchExternalSharedFilesRoutine.FAILURE:
      return {
        ...state,
        externalSharedFiles: {
          loading: false,
          error: action.payload,
          data: []
        }
      }
    case fetchInternalSharedUsersRoutine.REQUEST:
      return {
        ...state,
        internalSharedUsers: {
          loading: true,
          error: null,
          data: []
        }
      }
    case fetchInternalSharedUsersRoutine.SUCCESS:
      return {
        ...state,
        internalSharedUsers: {
          loading: false,
          error: null,
          data: action.payload
        }
      }
    case fetchInternalSharedUsersRoutine.FAILURE:
      return {
        ...state,
        internalSharedUsers: {
          loading: false,
          error: action.payload,
          data: []
        }
      }
    case bulkUnsharedFilesRoutine.REQUEST:
      return {
        ...state,
        bulkUnshareStatus: {
          loading: true,
          error: null
        }
      }
    case bulkUnsharedFilesRoutine.SUCCESS:
      return {
        ...state,
        bulkUnshareStatus: {
          loading: false,
          error: null
        }
      }
    case bulkUnsharedFilesRoutine.FAILURE:
      return {
        ...state,
        bulkUnshareStatus: {
          loading: false,
          error: action.payload
        }
      }
    case fetchSharedUsersForFilesRoutine.REQUEST:
      return {
        ...state,
        filesSharedUsers: {
          loading: true,
          error: null,
          data: {
            internalUsers: [],
            externalShares: []
          }
        }
      }
    case fetchSharedUsersForFilesRoutine.SUCCESS:
      return {
        ...state,
        filesSharedUsers: {
          loading: false,
          error: null,
          data: action.payload
        },
        sharedExternals: action.payload.externalShares || [],
        sharedInternals: action.payload.internalUsers || []
      }
    case fetchSharedUsersForFilesRoutine.FAILURE:
      return {
        ...state,
        filesSharedUsers: {
          loading: false,
          error: action.payload,
          data: {
            internalUsers: [],
            externalShares: []
          }
        }
      }
    case unshareAllFilesForEmailRoutine.REQUEST:
      return {
        ...state,
        bulkUnshareStatus: {
          loading: true,
          error: null
        }
      }
    case unshareAllFilesForEmailRoutine.SUCCESS:
      return {
        ...state,
        bulkUnshareStatus: {
          loading: false,
          error: null
        }
      }
    case unshareAllFilesForEmailRoutine.FAILURE:
      return {
        ...state,
        bulkUnshareStatus: {
          loading: false,
          error: action.payload
        }
      }
    case checkUserByEmailRoutine.SUCCESS:
      return {
        ...state,
        userFoundByEmail: action.payload
      }
    case bulkEditFilesRoutine.SUCCESS: {
      const { fileIds = [], updates = {} } = action.meta || {}

      return {
        ...state,
        bpFilesList: state.bpFilesList.map(file =>
          (fileIds || []).includes(file.id)
            ? {
              ...file,
              fileType: {
                ...(file.fileType || {}),
                id: updates.fileTypeId,
                fileCategoryId: updates.fileCategory
              },
              displayName: updates.displayName || file.displayName,
              versions: file.versions?.length
                ? file.versions.map((v, i) =>
                  i === 0
                    ? {
                      ...v,
                      producedBy: updates.producedBy ?? v.producedBy,
                      creationDate: updates.creationDate ?? v.creationDate,
                      legalOwner: updates.legalOwner ?? v.legalOwner,
                      expirationDate:
                        updates.expirationDate ?? v.expirationDate,
                      approvedBy: updates.approvedBy ?? v.approvedBy,
                      expirationReminderDate:
                        updates.expirationReminderDate ??
                        v.expirationReminderDate,
                      segment: updates.segment ?? v.segment,
                      dateOfIssue: updates.dateOfIssue ?? v.dateOfIssue
                    }
                    : v
                )
                : file.versions
            }
            : file
        )
      }
    }

    case accessControlFetchRoutine.REQUEST:
      return {
        ...state,
        invitations: {
          ...state.invitations,
          loading: true,
          error: null
        }
      }

    case accessControlFetchRoutine.SUCCESS:
      return {
        ...state,
        invitations: {
          loading: false,
          error: null,
          data: action.payload
        }
      }

    case accessControlFetchRoutine.FAILURE:
      return {
        ...state,
        invitations: {
          loading: false,
          error: action.payload,
          data: []
        }
      }

    case accessControlApproveRoutine.SUCCESS:
    case accessControlDenyRoutine.SUCCESS:
      return {
        ...state,
        invitations: {
          ...state.invitations,
          data: (state.invitations.data || []).filter(
            inv => inv.id !== action.payload?.invitationId
          )
        }
      }
    case fetchBpUnitsRoutine.REQUEST:
      return {
        ...state,
        units: [],
        unitsLoading: true,
        unitsError: null
      }

    case fetchBpUnitsRoutine.SUCCESS:
      return {
        ...state,
        units: action.payload.items,
        unitsLoading: false,
        unitsError: null
      }

    case fetchBpUnitsRoutine.FAILURE:
      return {
        ...state,
        units: [],
        unitsLoading: false,
        unitsError: action.payload
      }
    default:
      return state
  }
}
